import { eEstadoContratista } from "../common/enumModel";
import { IFilterContratistaModel } from "../interfaces/contratista/IFilterContratistaModel";

export class FilterContratistaModel implements IFilterContratistaModel {    
    contratista: string;
    ruc: string;
    idEstado: eEstadoContratista;
    idContratistas: number[];
    page: number;
    pageSize: number;
    idSede: number;
    companias: number[];

    constructor(){
        this.contratista = '';
        this.ruc = '';
        this.idEstado = eEstadoContratista.ACTIVO;
        this.idContratistas = new Array<number>();
        this.page = 1;
        this.pageSize = 30;
        this.idSede = 0;
        this.companias = new Array<number>();
    }
}